<template>
  <div class="payouts-by-registry-page">
    <div class="page__header">
      <div class="page__title">
        <router-link :to="backLinkRoute" class="page__back-link">
          <arrow-button
            class="page__back-link-icon"
            :rotated180="true"
          ></arrow-button>
        </router-link>
        <div class="page__title-text">
          {{
            payoutsRegistry.name ||
            $t('payouts.by-registry.registry-page.title-loading')
          }}
        </div>
      </div>
    </div>
    <loader v-if="isDataLoading"></loader>
    <component
      v-else
      :is="subPageComponent"
      :payouts-registry="payoutsRegistry"
      :payouts-registry-positions="payoutsRegistryPositions"
      @refresh="handleRefresh"
    ></component>
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { mapState } from 'vuex'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import PayoutsRegistryCreated from '@vue-app/views/company/Payouts/ByRegistry/SubPages/PayoutsRegistryCreated.vue'
import PayoutsRegistryMain from '@vue-app/views/company/Payouts/ByRegistry/SubPages/PayoutsRegistryMain.vue'

export default {
  name: 'PayoutsRegistry',
  components: {
    Loader,
    ArrowButton,
    PrimaryButton,
    PayoutsRegistryCreated,
    PayoutsRegistryMain,
  },
  props: {
    id: {
      type: [String, Number],
    },
    payoutsRegistryId: [String, Number],
  },
  mixins: [responsiveMixin],
  data() {
    return {
      payoutsRegistry: {},
      payoutsRegistryPositions: {},
      isDataLoading: true,
    }
  },

  computed: {
    ...mapState(['selectedCompany']),
    backLinkRoute() {
      return this.$router.resolve({
        name: 'company-payouts',
        params: {
          id: this.selectedCompany,
        },
        hash: '#by-registry',
      }).href
    },
    subPageComponent() {
      return this.payoutsRegistry?.status === 'new'
        ? 'PayoutsRegistryCreated'
        : 'PayoutsRegistryMain'
    },
  },
  created() {
    this.startupPage()
  },
  methods: {
    async startupPage() {
      this.isDataLoading = true
      await this.loadPayoutsRegistry()
      await this.loadPayoutsRegistryPositions()
      this.isDataLoading = false
    },
    async loadPayoutsRegistry() {
      this.payoutsRegistry =
        (await CompaniesApi.getPayoutsRegistry(this.id, this.payoutsRegistryId))
          .data || {}
    },
    async loadPayoutsRegistryPositions() {
      this.payoutsRegistryPositions =
        (
          await CompaniesApi.getPayoutsRegistryPositions(
            this.id,
            this.payoutsRegistryId
          )
        ).data || {}
    },
    handleRefresh() {
      this.startupPage()
    },
  },
}
</script>

<style lang="scss" scoped>
.payouts-by-registry-page {
  margin-top: 30px;
  .page {
    &__header {
      margin-bottom: 30px;
    }
  }

  .transactions-page-controls {
    margin-top: 30px;
  }

  .payouts-registries-table {
    margin-top: 10px;
  }
}
</style>
